export default "__VITE_ASSET__D1wi$JSh__"